import React, { useRef, useState } from "react";
import styled from "styled-components";

import GrayDocumentIcon from '../../../Image/GrayDocumentIcon.png';
import moment from "moment";

export default function RuleBookInputBox(props) {
  const { 
    isEdit, 
    value, 
    setValue,
    modifiedDate,
    division,
    uploadRuleBook,
    downloadRuleBook,
    deleteRuleBook
  } = props;
  
  const HiddenFileInput = useRef(null);
  const MainCanvasRef = useRef();

  const handleClick = e => {
    if (!isEdit) return;

    HiddenFileInput.current.click();
  };

  // 파일이름 결정 //
  function decideFileName() {
    if (value === '') return '파일 이름';
    else {
      let fileName = value.split('_RuleBook_')[1];
      let displayName = decodeURIComponent(fileName);
      
      return displayName;
    }
  }

  // 수정 날짜 표출 //
  function decideRuleBookModifiedDate() {
    return '수정일 : ' + moment(modifiedDate).format('YYYY.MM.DD');
  }

  // PDF파일 선택시 //
  function handleChange(e) {
    let pathpoint = e.target.value.lastIndexOf('.');
    let filepoint = e.target.value.substring(pathpoint + 1, e.target.length);
    let filetype = filepoint.toLowerCase();
    let selectFile = e.target.files;
    let file = null;

    if (filetype === 'pdf') {
      let fileToLoad = selectFile[0];
      let fileName = fileToLoad.name.replace(/\.pdf$/i, '');

      const fileReader = new FileReader();

      fileReader.onload = (e) => {
        file = e.target.result;

        if (file) {
          uploadRuleBook(file.toString(), fileName);
        }
      }

      fileReader.readAsDataURL(fileToLoad);
    }
    else {
      alert('.pdf 파일만 업로드 가능합니다!');
    }

    // ✅ 여기서 ref를 이용해 초기화
    if (HiddenFileInput.current) {
      HiddenFileInput.current.value = null;
    }
  };

  return (
    <TopLevelWrapper>
      <ColumnBox>
        <Text fontFamily='NotoSansKR-Black' fontSize={14} color='#2F2F32' cursor='default'>룰북</Text>
      </ColumnBox>
      <ViewBox>
        <Text fontFamily='NotoSansKR-Bold' fontSize={14} color='#FFFFFF' cursor='default'>{division + ' 룰북을 업로드 해주세요'}</Text>

        {/* <canvas ref={MainCanvasRef} style={{ display: 'none' }} /> */}
        <input
          type="file"
          ref={HiddenFileInput}
          onChange={handleChange}
          style={{ display: 'none' }} />
        <ImageWrapper>
        {
          value === '' &&
          <AddButton onClick={handleClick}>
            <PlusWrapper>
              <PlusStick width={34} height={4}/>
              <PlusStick width={4} height={34}/>
            </PlusWrapper>
          </AddButton>
        }
        {
          value !== '' &&
          <RuleBook>
            <TotalRuleBookImageWrapper>
              <RuleBookImageWrapper>
                <Image src={GrayDocumentIcon}/>
              </RuleBookImageWrapper>
            </TotalRuleBookImageWrapper>
            <RuleBookTextWrapper>
              <RuleBookIndividualTextWrapper>
                <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' cursor='default'>{decideFileName()}</Text>
              </RuleBookIndividualTextWrapper>
              <RuleBookIndividualTextWrapper>
                <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' cursor='default'>{decideRuleBookModifiedDate()}</Text>
              </RuleBookIndividualTextWrapper>
            </RuleBookTextWrapper>
            <RuleBookButtonWrapper>
              <Button backgroundColor='#6DD49E' onClick={downloadRuleBook}>
                <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' cursor='default'>다운받기</Text>
              </Button>
              <Button backgroundColor='#FF9898' onClick={deleteRuleBook}>
                <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' cursor='default'>삭제하기</Text>
              </Button>
            </RuleBookButtonWrapper>
          </RuleBook>
        }
        </ImageWrapper>
      </ViewBox>
    </TopLevelWrapper>
  );
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
`;

const ColumnBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 5px 10px;
  
  border-radius: 5px 5px 0px 0px;
  background-color: #6DD49E;
`;

const ViewBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  padding: 15px 15px 20px 15px;

  width: calc(100% - 30px);

  gap: 10px;

  border-radius: 0px 10px 10px 10px;
  background-color: #17171B;
`;

const ImageWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;

  gap: 12px;
`;

const AddButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: calc(23.55% - 4px);
  height: 223px;

  border: 2px dashed #909090;
  border-radius: 5px;
  background-color: #2F2F32;

  :hover {
    cursor: pointer;
  }
`;

const RuleBook = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  width: 23.55%;
  height: 227px;

  border-radius: 5px;
  background-color: #2F2F32;

  overflow: hidden;
`;

const TotalRuleBookImageWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 100%;
  height: 141px;

  background-color: #2F2F32;
`;

const RuleBookImageWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 84px;
  height: 84px;
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
`;

const RuleBookTextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  padding: 0px 10px;

  width: calc(100% - 20px);
  height: 45px;

  gap: 4px;
`;

const RuleBookIndividualTextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  padding: 0px 10px;

  width: 100%;
  height: 18px;

  overflow: hidden;
`;

const RuleBookButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
  height: 42px; 
`;

const Button = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 50%;
  height: 100%;
  
  background-color: ${props => props.backgroundColor};

  :hover {
    cursor: pointer;
  }
`;

const PlusWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 32px;
  height: 32px;
`;

const PlusStick = styled.div`
  position: absolute;

  width: ${props => props.width}px;
  height: ${props => props.height}px;

  border-radius: 4px;
  background-color: #969696;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;
  
  :hover {
    cursor: ${props => props.hover};
  }

  transition: all 0.3s ease-in-out;
`;